import { ReactComponent as CloseDialog } from 'assett/icons/close_dialog_icon.svg';
import { ReactComponent as Download } from 'assett/icons/download.svg';
import { ReactComponent as DownloadSlim } from 'assett/icons/download_arrow_slim.svg';
import { useFileOpener } from 'hooks/downloader.hook';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { Button, Dialog, IconButton, Stack, Typography } from 'styles';
import { TRANSLATION_KEYS } from 'utils/constants';
import { camelcaseToUnderscore } from 'utils/utils';

const FraudAttachmentsDetails = () => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const fileOpener = useFileOpener();
	const { fraudDetail } = useSelector((store: RootState) => store.fraudTracking);
	const [open, setOpen] = useState(false);

	const handleOpenDialog = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleClickDownload = (
		documentType: string,
		uuid: string | undefined,
		fileName: string | undefined,
	) => {
		if (!uuid || !fileName) return;

		const url = `${
			process.env.REACT_APP_API_URL
		}/attachments/${camelcaseToUnderscore(documentType)}/${uuid}/content`;
		fileOpener({ url, fileName, allowDownload: true });
	};

	return (
		<Stack flex={'true'} direction={'row'} gap={2.5}>
			<Dialog
				title={tClientLabels('dialog.downloadFrauds.title')}
				open={open}
				onClose={handleClose}
				variant="dialog"
				close={
					<IconButton disableRipple onClick={handleClose}>
						<CloseDialog />
					</IconButton>
				}
				actions={<></>}
				events={false}
				type=""
			>
				<Stack gap={'32px'}>
					{fraudDetail.attachments?.map(att => (
						<Stack
							key={att.uuid}
							direction={'row'}
							justifyContent={'space-between'}
							alignItems={'center'}
						>
							<Typography variant="caption" color={theme => theme.palette.grey2.main}>
								{att.fileName}
							</Typography>
							<IconButton
								color="inherit"
								onClick={() => handleClickDownload('fraud', att.uuid, att.fileName!)}
							>
								<DownloadSlim />
							</IconButton>
						</Stack>
					))}
				</Stack>
			</Dialog>

			{fraudDetail.attachments && fraudDetail.attachments.length > 0 && (
				<Button
					startIcon={<Download />}
					variant="outlined"
					onClick={handleOpenDialog}
				>
					{tClientLabels('fraud.downloadButton')}
				</Button>
			)}
		</Stack>
	);
};

export default FraudAttachmentsDetails;
